export const DatasetClientName = 'DatasetClient';
export const DatasetClientSymbol = Symbol.for(DatasetClientName);
